import { render, staticRenderFns } from "./PaymentPix.vue?vue&type=template&id=c9699adc&scoped=true&"
import script from "./PaymentPix.vue?vue&type=script&lang=js&"
export * from "./PaymentPix.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPix.vue?vue&type=style&index=0&id=c9699adc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9699adc",
  null
  
)

export default component.exports